import React from 'react';

export default function CRTOverlay() {
  return (
    <>
      <div className="crt-overlay" />
      <div className="grain" />
    </>
  );
}
